module.exports = __webpack_public_path__ + "80de278478b350d33e0739b46226652e.png";